/** V6 visibility mirrors its separate server-side release/access policy. */
export const V6FX_STRATEGY = 'V6FX';
// Independent of V5: changing either generation must not change the other.
export const V6FX_EARLY_ACCESS_ENABLED = true;
export const V6FX_EARLY_ACCESS_EMAILS: readonly string[] = [
  'contact@abanchev.com',
  'senyconsulting@gmail.com',
];
const allowed = new Set(V6FX_EARLY_ACCESS_EMAILS);
export const isV6fxEarlyAccess = (email?: string | null, enabled = V6FX_EARLY_ACCESS_ENABLED): boolean =>
  enabled && !!email && allowed.has(email.trim().toLowerCase());
